import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import imgResultadoPetTratamiento from "../../assets/tests/scn4/resultado-pet-tratamiento-next.jpg";
import imgEstudiosDra from "../../assets/img-caso/eventos-adversos.png";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { IconMicroscope, IconClipboardList } from "@tabler/icons-react";

function Scenario4Retroalimentacion({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = getScenarioNumByPath(location.pathname);

  return (
    <div className="h-100">
      <div className="container-fluid">
        <div className="row h-100">
          <div
            className="col-md-12 d-flex flex-column justify-content-around px-5 mt-2"
          >
            <h5 className="mb-1">Tras el ingreso hospitalario de Juan para iniciar el tratamiento con teclistamab, se presenta la siguiente tabla de monitorización clínica y analítica. En ella se detalla su evolución diaria entre el 13 y el 20 de abril, y se registra la respuesta del paciente a las dosis de escalonamiento</h5>
        		<div className="notaCasoClinicoAutor">caso clínico del autor</div>
            <div className="d-flex flex-column align-items-center">
              <img src={imgEstudiosDra} className="rounded shadow mt-3" style={{width: "86%"}}></img>
            </div>
            <div className="mt-3 d-flex align-items-center justify-content-end w-100">
              {/* Botón siguiente */}
              <NextButton
                navigateTo={ROUTES.SCENARIO4_RADIOTERAPIA}
                activeScenario={activeScenario}
                color="blue"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario4Retroalimentacion);
